<template>
    <div v-if="!loadingPage">
        <validation-observer #default="{ invalid }">
            <div class="d-flex justify-content-md-between align-items-center flex-md-row flex-column">
                <h3 class="mb-2 text-primary">رمز عبور</h3>
                <b-button type="submit" variant="primary" @click="changePassword" :disabled="invalid || loading"
                    class="d-flex mb-2 px-3">
                    <span>ذخیره</span>
                    <b-spinner v-if="loading" class="ml-50" variant="white" small></b-spinner>
                </b-button>
            </div>
            <b-card>
                <b-form class="row auth-login-form" @submit.prevent>

                    <b-form-group label="نام کاربری" label-for="usernameId" class="col-12 col-md-6 col-lg-3">
                        <b-form-input dir="ltr" id="usernameId" v-model="userName" name="username"
                            class="text-center font-weight-bolder user-select-none" disabled />
                    </b-form-group>

                    <b-form-group v-if="hasPassword" label="رمز عبور" label-for="currentPasswordId"
                        class="col-12 col-md-6 col-lg-3">
                        <b-form-input type="password" dir="ltr" id="currentPasswordId" v-model="form.currentPassword"
                            name="currentPassword" class="text-center font-weight-bolder user-select-none" />
                    </b-form-group>

                    <b-form-group label="رمز عبور جدید" label-for="newPasswordId" class="col-12 col-md-6 col-lg-3">
                        <validation-provider #default="{ errors }" name="رمز عبور جدید" rules="required|min:8|max:32">
                            <b-form-input type="password" dir="ltr" id="newPasswordId" v-model="form.newPassword"
                                name="newPassword" class="text-center font-weight-bolder user-select-none"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <b-form-group label="تکرار رمز عبور جدید" label-for="repeatNewPasswordId"
                        class="col-12 col-md-6 col-lg-3">
                        <validation-provider #default="{ errors }" name="تکرار رمز عبور جدید"
                            rules="required|min:8|max:32">
                            <b-form-input type="password" dir="ltr" id="repeatNewPasswordId" v-model="repeatNewPassword"
                                name="repeatNewPassword" class="text-center font-weight-bolder user-select-none"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-form>
            </b-card>
        </validation-observer>
    </div>
</template>

<script>
import { BRow, BCol, BButton, BCard, BCardText, BForm, BFormGroup, BFormInput, BSpinner } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, min, max } from '@validations';
import { storeService } from '@core/services';

export default {
    components: {
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BCard,
        BCardText,
        BSpinner,
        BButton,
        BForm,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        phoneNumber: {
            type: String,
            default: '',
        },
        hasPassword: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            required,
            min,
            max,
            loading: false,
            loadingPage: true,
            storeId: null,
            repeatNewPassword: null,
            form: {
                newPassword: null,
                currentPassword: null
            },
            userName: null
        };
    },
    methods: {
        changePassword() {
            this.loading = true
            if (this.repeatNewPassword == this.form.newPassword) {
                storeService.changePassword(this.storeId, this.form).then(({ data }) => {
                    this.$notif({ type: 'success', title: 'رمز عبور با موفقیت تغییر کرد' });
                    this.$router.push('/');
                })
                    .finally(() => {
                        this.loading = false
                    });
            }
            else {
                this.$notif({ type: 'error', title: 'رمز عبور جدید با تکرار آن یکسان نیست' });
                this.loading = false
            }
        }
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.userName = this.phoneNumber
        this.loadingPage = false
    },
};
</script>